let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("aDsl8")).then(() => parcelRequire('3u5Rs'));